module.exports = __webpack_public_path__ + "exo-latin-500.6596ef88679c21505494.svg";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-500.svg
// module id = ../../../../typeface-exo/files/exo-latin-500.svg
// module chunks = styles